const ArrowsCircle = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.16665 1L9.49998 3.16667L7.16665 5.33333M8.83331 10.6667L6.49998 12.8333L8.83331 15M7.16665 12.8333H9.33331C12.0027 12.8333 14.1666 10.6694 14.1666 8C14.1666 6.54336 13.5223 5.23722 12.503 4.35107M8.83331 3.16667H6.66665C3.99727 3.16667 1.83331 5.33062 1.83331 8C1.83331 9.45695 2.47795 10.7633 3.49756 11.6495"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowsCircle
